module.exports = __webpack_public_path__ + "static/img/bg19.6d35ea2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg19.png
// module id = 9NAt
// module chunks = 1